import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Pipe({
    name: 'bannerNotificationInterdictionMessage',
    pure: false,
    standalone: false
})
export class BannerNotificationInterdictionMessagePipe extends TranslatePipe implements PipeTransform {

  override transform(value: string | undefined | null): string {
    if (!value) return ''
    return super.transform('agent.notifications.board.interdiction.message', { countDown: value })
  }

}
